





























































import { Component, Vue, Watch } from 'vue-property-decorator'
import { Getter } from 'vuex-class'
import comments from '../components/comments.vue'
import SearchAreaModel from '../models/SearchAreaModel'
import SearchAreaStatusEnum from '../enums/searchAreaStatusEnum'

@Component({
  components: {
    comments
  }
})

export default class Report extends Vue {
  @Getter('searchAreas') searchAreasAll !: Array<SearchAreaModel>

  @Watch('$route', { immediate: true, deep: true })
  onUrlChangeReport (newVal: any) {
    if (!this.$store.state.reportModule.report.vehicleType.id) {
      this.$router.push({ name: 'home' })
    } else {
      this.$store.dispatch('updateStep', 5)
    }
  }

  get searchAreas () {
    return this.searchAreasAll.slice(0, 3)
  }

  get reportStatus () : string {
    let reportStatus = 'Accepted'
    for (let index = 0; index < this.searchAreasAll.length; index++) {
      if (this.searchAreasAll[index].status === SearchAreaStatusEnum.Declined) {
        reportStatus = 'Declined'
        break
      } else if (this.searchAreasAll[index].status === SearchAreaStatusEnum.InProgress) {
        reportStatus = 'InProgress'
        break
      }
    }

    return reportStatus
  }

  getSearchAreaIcon (searchArea: SearchAreaModel) : string {
    if (searchArea.status === SearchAreaStatusEnum.Accepted) {
      return 'check-circle'
    } else if (searchArea.status === SearchAreaStatusEnum.Declined) {
      return 'times-circle'
    } else {
      return 'exclamation-circle'
    }
  }

  getSearchAreaIconColor (searchArea: SearchAreaModel) {
    if (searchArea.status === SearchAreaStatusEnum.Accepted) {
      return 'bg-green'
    } else if (searchArea.status === SearchAreaStatusEnum.Declined) {
      return 'bg-red'
    } else {
      return 'bg-grey'
    }
  }

  sendReport (status: string) {
    this.$store.commit('setReportStatus', status)
    this.$store.dispatch('sendReport').then(() => {
      this.$router.push({ name: 'home' })
    })
  }

}
